<template>
    <div>
         <div class="available-credits">
                    <div class="title">{{$t('cAgentDetail.availBal')}}</div>
                    <div v-if="balanceDet" class="row">
                      <div
                        v-for="item in balanceDet"
                        :key="item.financeid"
                        class="col-md-6"
                      >
                        <div v-if="item.symbol" class="box-shadow-card usd">
                            <div class="currency_sign">
                                {{item.symbol}}
                            </div>
                          <div class="d-flex">
                            <div class="icon-symbol" v-if="item.symbol">{{item.symbol}}</div>
                            <div class="wrapper">
                              <div class="currency-name" v-if="item.currecycode">{{item.currecycode}}</div>
                              <div v-if="item.agenttype && item.agenttype == agentType.prepaid">
                              <div class="money-value" v-if="item.prepaidbalance">{{item.prepaidbalance|formatNumber(item.currecycode)}}</div>
                              </div>
                              <div v-if="item.agenttype && item.agenttype == agentType.postpaid">
                              <div class="money-value" v-if="item.postpaid_runningamount&&item.postpaidlimit">{{getPostPaidAmt(item.postpaidlimit,item.postpaid_runningamount)|formatNumber(item.currecycode)}}</div>
                              </div>
                            </div>
                          </div>
                          <CProgress color="success" animated variant="success" height="0.4rem" :value="46" />
                        </div>
                      </div>
                    </div>
                  </div>

    </div>
</template>

<script>
import BaseConfiguration from "../../config/base";

import {
  LOG_TYPE,

} from "../../config/API_DATA";
import { COMPONENT_NAME, APPROVEAGENT } from "../../util/constants";
import { parseNumber } from "../../util/util";
import Logger from "../../services/logger";

export default {
    name: COMPONENT_NAME.C_AGENT_BALANCE_DETAIL,

    props: {
        // agencyDet : {
        //     type: Object|Array,
        //     default : null
        // },
        balanceDet: {
          type: Object|Array,
          default: null
        }
    },

    data(){
      return{
        agentType: {
        prepaid: APPROVEAGENT.PREPAID,
        postpaid: APPROVEAGENT.POSTPAID
      }
      }
    },

    
        methods:{
           getPostPaidAmt(pPostPaidLimit,pPostPaidRunAmt) {
        let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getPostPaidAmt");
          
          retValue=parseNumber(pPostPaidLimit)-parseNumber(pPostPaidRunAmt);
          
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_LOGIN_INFO,
                  "error in getPostPaidAmt",
                  err.toString(),
                  "getPostPaidAmt",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

        }
}
</script>